export const CKycSubmitted = {
    STORAGE_SUBMITTED_TIME : 'submitted-process-time',
    FIRST_MESSAGE_TIME : 1,
    SECOND_MESSAGE_TIME : 2
} as const;